import request from '@/common/request'

export default {
    // 钥匙激活
    activateKey: data => {
        return request({
            url: '/v1/publishManage/activateKey',
            method: 'put',
            data
        })
    },
    // 锁激活
    activateLock: data => {
        return request({
            url: '/v1/publishManage/activateLock',
            method: 'put',
            data
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/modules/activate.js